import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Modal from '../../Modal/ModalBasic';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { FeaturedAppointmentItem } from './FeatureAppointmentItem';
import { ButtonCustomSmall } from '../../JourneyActionManager/AwaitingScheduleReturn/ChooseReturnType/styled';
import AvailableAddress from '../AvailableAddress';
import { FeaturedScheduleDay, IAppointments } from '../../../../services/availableTimes.service';
import FeaturedAppointmentsViewModel from './viewModel';

interface ISelectAvailableTimes {
  open: boolean;
  onFinished?: () => void;
  featuredScheduleDays: FeaturedScheduleDay[];
  appointments: IAppointments;
}

const FeaturedAppointments = ({ open, featuredScheduleDays, appointments, onFinished }: ISelectAvailableTimes) => {
  const { dateStart, canContinue, onClose, onChooseCalendar, onBack, onContinue } = FeaturedAppointmentsViewModel({
    featuredScheduleDays,
    onFinished
  });

  return (
    <Modal open={open} onCloseHandler={onClose} title={'Escolha a melhor data para o seu atendimento'} typeTitle="h3">
      <FeaturedAppointmentItem featuredScheduleDays={featuredScheduleDays} />

      <ButtonCustomSmall onClick={onChooseCalendar}>
        <Typography variant="body1R">Escolher no calendário</Typography>
      </ButtonCustomSmall>

      {dateStart.length > 0 && <AvailableAddress appointments={appointments} />}

      <Box sx={{ display: 'flex', paddingBottom: '24px', paddingRight: '10px', justifyContent: 'space-between', mt: 2 }}>
        <Button variant="contained" color="secondary" onClick={onBack}>
          <ArrowBackIcon />
          <Typography variant="body1" sx={{ ml: 1.5 }}>
            Voltar
          </Typography>
        </Button>

        <Button variant="contained" disabled={!canContinue} onClick={onContinue} endIcon={<ArrowForwardIcon />}>
          Continuar
        </Button>
      </Box>
    </Modal>
  );
};

export default FeaturedAppointments;
